export default "__VITE_ASSET__kpCihARy__"